import { useSessionStorage } from './useSessionStorage';
import { useState } from 'react';

const KEY = 'AUTH';

export type AuthType = {
  token?: string;
  email?: string;
};

export const useAuth = (): [AuthType, (val: AuthType) => void] => {
  const initValue: AuthType = {};

  const [savedValue, setValue] = useSessionStorage(KEY, initValue);

  const value: AuthType = {
    token: savedValue.token,
    email: savedValue.email,
  };

  const setAuth = (val: AuthType) => {
    setValue(val);
    setAuthState(val);
  };

  const [auth, setAuthState] = useState(value);
  return [auth, setAuth];
};
